export function transformString(str: string) {
  if (!str) return ""
  return str
    .split("_")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
}
